// extracted by mini-css-extract-plugin
export default {"section":"Legal_section__iVfmR","container":"Legal_container__7P9Oa","title":"Legal_title__FR+tr","date":"Legal_date__mWKcq","content":"Legal_content__lC8fs"};